import React from 'react';
import { Navigate } from "react-router-dom";
import PropTypes from 'prop-types';

const GuardedRoute = ({ element, role, pathname }) => {
    const allowed =
        !(role.includes('Manager')) ||
        (
          role.includes('Manager') &&
          (pathname.includes('operator')) ||
          (pathname.includes('camera'))
        );
    return allowed ? element : <Navigate to='/' />;
};

export default GuardedRoute;

GuardedRoute.propTypes = {
  element: PropTypes.element,
  role: PropTypes.arrayOf(PropTypes.string),
  pathname: PropTypes.string,
};